import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import locationColumnTemplate from './location-column-template.pug';

/**
 * Displays location column.
 */

function generateLocationName({
  i18n,
  criterion,
}) {
  if (criterion.Type === 'Location') {
    return criterion.LocationCriterion.Name;
  }
  return i18n.getString('Inline_Location_Radius_Formatter', {
    lat: i18n.formatDecimalToFixed(criterion.RadiusCriterion.Latitude),
    long: i18n.formatDecimalToFixed(criterion.RadiusCriterion.Longitude),
  });
}

export class Location extends ProjectionGridBaseColumn {
  constructor({ deps, columnOverrider, isForVNext }) {
    const localizedTitle = deps.i18n.getString('LocationGrid_Column_Header_Recommended_Location');

    super({
      name: 'Location',
      property: 'Criterion',
      title: 'LocationGrid_Column_Header_Recommended_Location',
      i18n: deps.i18n,
      bodyClasses: ['text-left'],
      helpId: '',
      sortable: ({ Criterion: criterion }) => generateLocationName({
        i18n: deps.i18n,
        criterion,
      }),
      helpAriaLabel: deps.i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
      ...columnOverrider.Location,
    });
    this.i18n = deps.i18n;
    this.isForVNext = isForVNext;
  }

  template({ value }) {
    return locationColumnTemplate({
      Name: generateLocationName({
        i18n: this.i18n,
        criterion: value,
      }),
      isForVNext: this.isForVNext,
    });
  }
}
